import { useSelector } from "react-redux";
import { DEFAULT_DATE_FORMAT } from "../appRedux/reducers/Common";

/**
 * Returns the company's configured Date Format (Settings → Date/Time
 * Configurations), e.g. "DD-MM-YYYY", "MM/DD/YYYY".
 *
 * The value is fetched once on app load (see containers/App/MainApp.js) and
 * cached in Redux (`common.dateFormat`) - this hook just reads it. Falls back
 * to DEFAULT_DATE_FORMAT ("DD-MM-YYYY") if it hasn't loaded yet or the fetch
 * failed, so callers never need a null-check.
 *
 * @returns {string} moment.js format token
 */
const useCompanyDateFormat = () => {
  return useSelector(({ common }) => common?.dateFormat || DEFAULT_DATE_FORMAT);
};

export default useCompanyDateFormat;
